import { render, staticRenderFns } from "./CartInCheckout.vue?vue&type=template&id=07122af5"
import script from "./CartInCheckout.vue?vue&type=script&lang=js"
export * from "./CartInCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports